import { forwardRef, useEffect, useRef, useState } from "react";

// Shows the website at its real width (e.g. 1440px desktop) and shrinks it to fit the editor,
// so the full desktop menu and layout are visible and clickable.
export const ScaledFrame = forwardRef(({ width, src, onLoad }, ref) => {
  const box = useRef(null);
  const [size, setSize] = useState({ w: 1000, h: 700 });
  useEffect(() => {
    const el = box.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setSize({ w: e.contentRect.width, h: e.contentRect.height }));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const scale = Math.min(1, (size.w - 16) / width);
  const left = Math.max(0, (size.w - width * scale) / 2);
  const post = () => ref?.current?.contentWindow?.postMessage({ type: "ve-scale", scale }, window.location.origin);
  useEffect(() => { post(); }); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div ref={box} className="absolute inset-0 overflow-hidden">
      <iframe
        ref={ref}
        onLoad={() => { onLoad?.(); setTimeout(post, 700); }}
        data-testid="ve-frame"
        title="Website preview"
        src={src}
        style={{ width, height: size.h / scale, transform: `scale(${scale})`, transformOrigin: "top left", left }}
        className="absolute top-0 bg-white shadow-sm"
      />
      <span data-testid="ve-zoom" className="pointer-events-none absolute bottom-2 right-3 rounded-full bg-white/90 px-2 py-0.5 font-mono text-[10px] text-[#4A5568]">{width}px · {Math.round(scale * 100)}%</span>
    </div>
  );
});
ScaledFrame.displayName = "ScaledFrame";
